<template>
  <v-container>
    <div class="breadcrumbs mt-5 mb-15">
      <div
        class="font-weight-bold"
        style="font-size: 30px; cursor: pointer"
        @click="$router.go(-1)"
      >
        {{ $t("Profile") }}
      </div>
      <v-icon icon="mdi-slash-forward" style="font-size: 40px"></v-icon>
      <p style="font-size: 24px">
        {{ $t("Subscriptions") }}
      </p>
    </div>
    
    <!-- My Active Subscriptions Section -->
    <div v-if="userSubscriptions.length > 0" class="my-subscriptions-section mb-8">
      <h2 class="section-title mb-4">{{ $t("My_Active_Subscriptions") || "اشتراكاتي النشطة" }}</h2>
      <v-row>
        <v-col cols="12" md="6" lg="4" v-for="(subscription, index) in userSubscriptions" :key="subscription.id">
          <v-card class="subscription-card active-subscription" elevation="2">
            <v-card-title class="d-flex justify-space-between align-center">
              <span class="font-weight-bold">{{ subscription.name }}</span>
              <v-chip color="success" size="small">
                <v-icon start icon="mdi-check-circle"></v-icon>
                {{ $t("Active") || "نشط" }}
              </v-chip>
            </v-card-title>
            <v-card-text>
              <div class="subscription-details">
                <div class="detail-item">
                  <v-icon size="18" class="mr-2">mdi-clock-outline</v-icon>
                  <span>{{ subscription.duration }}</span>
                </div>
                <div class="detail-item">
                  <v-icon size="18" class="mr-2">mdi-newspaper</v-icon>
                  <span>{{ $t("Regular_ads") || "إعلانات عادية" }}: {{ subscription.regular_ads }}</span>
                </div>
                <div class="detail-item">
                  <v-icon size="18" class="mr-2">mdi-star</v-icon>
                  <span>{{ $t("Special_ads") || "إعلانات مميزة" }}: {{ subscription.special_ads }}</span>
                </div>
                <div v-if="subscription.description" class="description mt-3">
                  <p class="text-caption description-text">{{ subscription.description }}</p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    
    <individual class="my-11" :user-subscriptions="userSubscriptions"/>
    <institution class="my-11" :user-subscriptions="userSubscriptions"/>
  </v-container>
</template>
<script>
import individual from './individual.vue';
import institution from './institution.vue';
import crudDataService from "@/Services/crudDataService";

export default {
  components:{
    individual,
    institution
  },
  data() {
    return {
      userSubscriptions: [],
      loading: false,
    };
  },
  methods: {
    async getUserSubscriptions() {
      this.loading = true;
      try {
        const response = await crudDataService.getAll(`subscriptions`);
        if (response.data && response.data.data) {
          this.userSubscriptions = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching user subscriptions:', error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getUserSubscriptions();
  },
};
</script>

<style lang="scss" scoped>
.my-subscriptions-section {
  margin-bottom: 32px;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 20px;
}

.subscription-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  height: auto;
  max-height: 400px;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
  }
  
  &.active-subscription {
    border: 2px solid #10b981;
    background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);
  }
}

.subscription-details {
  .detail-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    font-size: 14px;
    color: #4b5563;
    
    .v-icon {
      color: #10b981;
    }
  }
  
  .description {
    padding-top: 12px;
    border-top: 1px solid #e5e7eb;
    color: #6b7280;
    font-size: 13px;
    line-height: 1.5;
    
    .description-text {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 4.5em;
      line-height: 1.5em;
      margin: 0;
    }
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 20px;
  }
}
</style>
